import React from 'react';
import PlanAwareLink from '../billing/PlanAwareLink';
import { LuBell, LuUsers } from 'react-icons/lu';
import { useTeamContextOptional } from '../../context/TeamContext';
import TeamGlobalRequestsPanel from '../teams/TeamGlobalRequestsPanel';
import PlanTierLabel from '../billing/PlanTierLabel';
import { useUserPlan } from '../../hooks/useUserPlan';

export default function StudyHubTeamInbox({ placement = 'main' }) {
  const inRail = placement === 'rail';
  const team = useTeamContextOptional();
  const { canAccessTeams } = useUserPlan();
  const pendingCount = team?.pendingRequestCount ?? 0;
  const showTeamsLink = true;

  return (
    <section
      id="team-notifications"
      className={`sh-block sh-block--team-inbox${inRail ? ' sh-block--team-inbox-rail' : ''}`}
    >
      <header className="sh-block-head sh-block-head--team-inbox">
        <div className="sh-block-head-main">
          <span className="sh-block-icon" aria-hidden>
            {pendingCount > 0 ? <LuBell /> : <LuUsers />}
          </span>
          <div className="sh-block-head-copy">
            <h2 className="sh-block-title sh-block-title--with-meta">
              <span className="sh-block-title-text">Team notifications</span>
              {!canAccessTeams && <PlanTierLabel tier="Team" className="sh-block-title-badge" />}
              {pendingCount > 0 && (
                <span className="sh-team-inbox-count">{pendingCount}</span>
              )}
            </h2>
            <p className="sh-block-sub">
              {pendingCount > 0
                ? `${pendingCount} pending invite${pendingCount === 1 ? '' : 's'} — accept to start tracking progress.`
                : 'Workspace, assignment, and challenge invites from your teams.'}
            </p>
          </div>
        </div>
        {!inRail && showTeamsLink && (
          <PlanAwareLink to="/teams" className="sh-block-link">
            Teams
            {!canAccessTeams && <PlanTierLabel tier="Team" />}
          </PlanAwareLink>
        )}
      </header>

      <TeamGlobalRequestsPanel
        showWhenEmpty={pendingCount === 0}
        hideTeamsLink={inRail}
        compact={inRail}
      />
      {inRail && showTeamsLink && (
        <PlanAwareLink to="/teams" className="sh-block-link sh-block-link--rail-teams">
          Open Teams
        </PlanAwareLink>
      )}
    </section>
  );
}
